export default __webpack_public_path__ + "static/media/SparkleRight.8690d35c.svg";